import CommonHeaderForPC from './CommonHeaderForPC';
import CommonHeaderForSmartPhone from './CommonHeaderForSmartPhone';

/**
 * 共通ヘッダー
 */
const CommonHeader = () => {
    return (
        <>
            <CommonHeaderForPC />
            <CommonHeaderForSmartPhone />
        </>
    );
};

export default CommonHeader;
